module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.isLoading),
      expression: "isLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "id": "app",
      "element-loading-text": "Carregando Dados...",
      "element-loading-background": "rgba(0, 0, 0, .8)"
    }
  }, [(_vm.isLogged) ? _c('AppHeader') : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('AppSidebar') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    class: {
      'container': _vm.isLogged
    }
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-690360c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/Main.vue
// module id = 762
// module chunks = 2